export default {
  setData: (state, data) => {
    state.data = data;
  },
};
